export type Theme = 'light' | 'dark';

/** localStorage key of the manual theme choice. */
export const THEME_KEY = 'theme';

/** A saved manual choice wins over Telegram's scheme; anything else in storage is ignored. */
export function resolveTheme(telegram: Theme, saved: string | null): Theme {
  return saved === 'light' || saved === 'dark' ? saved : telegram;
}

export function readSavedTheme(storage: Pick<Storage, 'getItem'> | null): string | null {
  if (!storage) return null;
  try {
    return storage.getItem(THEME_KEY);
  } catch {
    return null;
  }
}

export function saveTheme(theme: Theme, storage: Pick<Storage, 'setItem'> | null): void {
  if (!storage) return;
  try {
    storage.setItem(THEME_KEY, theme);
  } catch {
    // No storage (private mode, blocked site data): the choice lives until reload.
  }
}

export function otherTheme(theme: Theme): Theme {
  return theme === 'light' ? 'dark' : 'light';
}
